import { FC, useEffect } from 'react';
import { useDetectAdBlock } from 'adblock-detect-react';

import { GptType, ResponsiveSizeType } from 'src/interface/AdSlot/index';

import classes from './index.module.less';

const GPT: FC<GptType> = ({ adUnit, name, target = [], type, size, className, style }) => {
	const adBlockDetected = useDetectAdBlock();

	let googletag: any;
	let adSlot: any = null;
	const classNameC = className ? ` ${className}` : '';

	const setTargeting = () => {
		target.forEach((el: any) => googletag.pubads().setTargeting(el[0], el[1]));
	};

	const generateSize = () => {
		const internalSize = size as ResponsiveSizeType;

		if (!(typeof internalSize === 'object' && typeof internalSize[0][1] === 'object')) return size;

		return internalSize.reduce((uniqueSizes: any, elSize: any) => {
			const haveSize = !!uniqueSizes.find((mapSize: [number, number]) => mapSize[0] === elSize[0]);

			if (haveSize) uniqueSizes.push(haveSize);
			return uniqueSizes;
		}, []);
	};

	const mappingSize = () => {
		const internalSize = size as ResponsiveSizeType;

		if (!(typeof internalSize === 'object' && typeof internalSize[0][1] === 'object')) return;

		let mapping = googletag.sizeMapping();
		internalSize.forEach((el) => (mapping = mapping.addSize(el)));
		mapping = mapping.build();
		adSlot.defineSizeMapping(mapping);
	};

	const displayCommonAd = () => {
		googletag.cmd.push(() => {
			adSlot = googletag.defineSlot(adUnit, generateSize(), name).addService(googletag.pubads());
			mappingSize();
			setTargeting();
			googletag.pubads().collapseEmptyDivs();
			googletag.pubads().enableSingleRequest();
			googletag.enableServices();
			googletag.display(name);
		});
	};

	const displayEspecialAd = () => {
		if (type) {
			googletag.cmd.push(() => {
				adSlot = googletag.defineOutOfPageSlot(adUnit, googletag.enums.OutOfPageFormat[type]);

				if (!adSlot) return;

				setTargeting();
				adSlot.addService(googletag.pubads());
			});
		}
	};

	useEffect(() => {
		window.googletag = window.googletag || { cmd: [] };
		googletag = window.googletag;

		if (adUnit) {
			googletag.cmd.push(() => {
				if (type) {
					displayEspecialAd();
				} else {
					displayCommonAd();
				}
			});
		}

		return () => {
			if (googletag.destroySlots) {
				googletag.destroySlots([adSlot]);
			}
		};
	}, []);

	if (adBlockDetected || !adUnit || type) return null;

	return <div id={name} className={`${classes.gpt}${classNameC}`} style={style} />;
};

export default GPT;
